import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dFix from "../Specular.FRP.Fix/index.js";
import * as Specular$dFRP$dWeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dJQuery from "../Specular.JQuery/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import {getValues, initSelect2Impl, open, setValues} from "./foreign.js";
const initSelect2 = () => initSelect2Impl;
const group = Unsafe$dCoerce.unsafeCoerce;
const entry = Unsafe$dCoerce.unsafeCoerce;
const fromSelectOptions = dictShow => Data$dFunctor.arrayMap(v => {
  if (v.tag === "OptGroup") { return {text: v._1.label, children: Data$dFunctor.arrayMap(opt => ({id: dictShow.show(opt.key), option: opt.key, text: opt.label}))(v._1.options)}; }
  if (v.tag === "SingleOption") { return {id: dictShow.show(v._1.key), option: v._1.key, text: v._1.label}; }
  $runtime.fail();
});
const multiSelectView = dictEq => () => config => value => {
  const entries = Data$dArray.zipWith(index => x => ({id: Data$dShow.showIntImpl(index), text: config.display(x), option: x}))(Data$dArray.range(0)(config.options.length - 1 | 0))(config.options);
  return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBuilder.monadDomBuilderBuilder["elDynAttrNS'"](Data$dMaybe.Nothing)("input")(Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure((() => {
    const $0 = {};
    $0.type = "hidden";
    return $0;
  })()))(Specular$dInternal$dRIO.pureImpl()))(v => {
    const $0 = v._1;
    const jq = Specular$dJQuery.fromNode($0);
    return Specular$dInternal$dRIO.bindImpl(initSelect2Impl(jq)({
      data: (() => {
        const $1 = {results: Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce)(entries)};
        return () => $1;
      })(),
      containerCssClass: "form-control",
      multiple: true,
      placeholder: config.placeholder
    }))(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dWeakDynamic.subscribeWeakDyn_({
      MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
      MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
    })((() => {
      const $1 = setValues(jq);
      const $2 = Data$dArray.mapMaybe(x => {
        const $2 = Data$dArray.findIndex(e => dictEq.eq(e.option)(x))(entries);
        if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", entries[$2._1]); }
        return Data$dMaybe.Nothing;
      });
      return x => $1($2(x));
    })())(value))(() => Specular$dJQuery.jQueryEventWithSample({
      MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
      MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
    })(v1 => {
      const $1 = Data$dFunctor.arrayMap(v2 => v2.option);
      const $2 = getValues(jq);
      return () => {
        const a$p = $2();
        return $1(a$p);
      };
    })("change")($0)));
  });
};
const multiSelect = dictEq => () => config => initial => Specular$dFRP$dFix.fixDyn({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(value$p => Specular$dInternal$dRIO.bindImpl(multiSelectView(dictEq)()(config)(value$p))(change => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.foldDyn({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(x => v => x)(initial)(change))(value => Specular$dInternal$dRIO.pureImpl(Data$dTuple.$Tuple(value, value)))));
export {entry, fromSelectOptions, group, initSelect2, multiSelect, multiSelectView};
export * from "./foreign.js";
